
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/datenschutz",
      function () {
        return require("private-next-pages/datenschutz/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/datenschutz"])
      });
    }
  